
        require('./index.scss');
        'use strict';

var flag = $('.cross-ad a').attr('data-flag');
if (flag == '1') $('.cross-ad a').addClass('ad');;
    


// WEBPACK FOOTER //
// ./src/module/home-list/cross-ad/index.js